/**
 * sl-m82f.4.2: Business Intelligence feature tab. Per-document knowledge
 * graph extraction cost breakdown.
 */
import { useI18n } from '@affine/i18n';

import { fetchKgByDoc } from '../api';
import type { AnalyticsPeriodRange, FeatureTotals } from '../types';
import { LabeledFeatureTab } from './labeled-feature-tab';

export interface BusinessIntelligenceTabProps {
  workspaceId: string;
  period: string | AnalyticsPeriodRange;
  featureTotals: FeatureTotals;
}

export const BusinessIntelligenceTab = ({
  workspaceId,
  period,
  featureTotals,
}: BusinessIntelligenceTabProps) => {
  const t = useI18n();
  return (
    <LabeledFeatureTab
      cacheKey="business-intelligence"
      workspaceId={workspaceId}
      period={period}
      featureCredits={featureTotals.features.businessIntelligence}
      fetcher={fetchKgByDoc}
      docSource
      nameHeader={
        t[
          'com.streamlain.settings.workspace.ai.analytics.table.document-header'
        ]?.() ?? 'Document'
      }
      itemsLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.card.documents-graphed'
        ]?.() ?? 'Documents graphed'
      }
      topLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.card.top-document'
        ]?.() ?? 'Top document'
      }
      emptyLabel={
        t['com.streamlain.settings.workspace.ai.analytics.empty.graph']?.() ??
        'No knowledge graph operations in this period'
      }
      countLabel={
        t[
          'com.streamlain.settings.workspace.ai.analytics.table.operations-header'
        ]?.() ?? 'Operations'
      }
    />
  );
};
